import { render } from "./ResourceTiles.vue?vue&type=template&id=6b2eac48"
import script from "./ResourceTiles.vue?vue&type=script&lang=js"
export * from "./ResourceTiles.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__